import { useEffect, useState } from 'react';
/**
 * Debounce hook -- wait a period of time before letting a newly set value through.
 *
 * @param value A new value to set
 * @param delay The delay before the new value propagates, in milliseconds
 */
export const useDebounce = (value, delay) => {
    const [debouncedValue, setDebouncedValue] = useState(value);
    useEffect(() => {
        const handler = setTimeout(() => {
            setDebouncedValue(value);
        }, delay);
        // Cancel the timeout if value changes (also on delay change or unmount)
        // This is how we prevent debounced value from updating if value is changed ...
        // .. within the delay period. Timeout gets cleared and restarted.
        return () => {
            clearTimeout(handler);
        };
    }, [value, delay]);
    return debouncedValue;
};
//# sourceMappingURL=useDebounce.js.map